import { IonProgressBar, IonSearchbar } from '@ionic/react';

import classNames from 'classnames';
import { searchOutline } from 'ionicons/icons';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './FormFields.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';

interface SearchBarProps {
	className?: string;
	placeholder?: string;
	searchIcon?: string;
	value: string;
	onFocus?: () => void;
	onBlur?: () => void;
	onCancel?: () => void;
	onClear?: () => void;
	onChangeAction: (e: any) => void;
	isFetching?: boolean;
	isLoading?: boolean;
	testId?: string;
	debounce?: number;
}

export const SearchBar: React.FC<SearchBarProps> = ({
	className,
	placeholder,
	searchIcon,
	value,
	onFocus,
	onBlur,
	onCancel,
	onClear,
	onChangeAction,
	isFetching,
	isLoading,
	testId,
	debounce = 0
}) => {
	return (
		<div className={sharedStyles.IonSearchbarContainer} data-testid={testId}>
			<IonSearchbar
				className={className || classNames(sharedStyles.searchAutoComplete, styles.input)}
				placeholder={placeholder}
				showClearButton="focus"
				searchIcon={searchIcon || searchOutline}
				value={value}
				debounce={debounce}
				onFocus={onFocus}
				onBlur={onBlur}
				onIonCancel={onCancel}
				onIonClear={onClear}
				onIonInput={onChangeAction}
			></IonSearchbar>

			<div className={sharedStyles.IonProgressBarContainer}>
				<IonProgressBar
					className={sharedStyles.progressBar}
					type="indeterminate"
					hidden={!isFetching && !isLoading}
				/>
			</div>
		</div>
	);
};
